import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail, MapPin, Phone, Wine } from 'lucide-react';

const socialLinks = [
  {
    label: 'PetCart on LinkedIn',
    href: 'https://www.linkedin.com/company/petcart/',
    Icon: Linkedin,
  },
  {
    label: 'PetCart on Instagram',
    href: 'https://www.instagram.com/petcartin?igsh=emZqMG9vZTYzcHlr',
    Icon: Instagram,
  },
  {
    label: 'Wag & Wine on Instagram',
    href: 'https://www.instagram.com/waganwine?igsh=aGtnM3BmcTQyd3hq',
    Icon: Wine,
  },
];

const columns = {
  Services: [
    { label: 'Dog Boarding', to: '/services/dog-boarding' },
    { label: 'Dog Walking', to: '/services/dog-walking' },
    { label: 'Day Care', to: '/services/daycare' },
    { label: 'Recreation', to: '/services/recreation' },
    { label: 'Grooming', to: '/services/grooming' },
  ],
  Company: [
    { label: 'About Us', to: '/about' },
    { label: 'Our Story', to: '/our-story' },
    { label: 'Careers', to: '/careers' },
    { label: 'Press & Media', to: '/press' },
  ],
  Resources: [
    { label: 'FAQs', to: '/faqs' },
    { label: 'News & Articles', to: '/news' },
    { label: 'Pet Care Tips', to: '/pet-care-tips' },
    { label: 'Community Events', to: '/community-events' },
  ],
  Legal: [
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Terms of Service', to: '/terms-of-service' },
    { label: 'Cookie Policy', to: '/cookie-policy' },
    { label: 'Refund Policy', to: '/refund-policy' },
  ],
};

const Footer = () => {
  return (
    <footer id="contact" className="bg-neutral-900 text-white">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-9 sm:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <img
              src="/images/logo-petcart-color.png"
              alt="PetCart Logo"
              className="mb-4 h-8 w-auto sm:h-9"
            />
            <p className="landing-footer-tagline">The Ecosystem for Your Pet's Life.</p>
            <div className="space-y-3 landing-footer-note">
              <p className="flex gap-2"><MapPin size={14} /> Survey No 136/18, V Kallhalli, Sarjapura Main Road, Anekal TQ, Bangalore 562125</p>
              <p className="flex gap-2"><Phone size={14} /> +91 88617 12345</p>
              <p className="flex gap-2"><Mail size={14} /> shekhar@petcart.com</p>
            </div>
          </div>

          {Object.entries(columns).map(([title, links]) => (
            <div key={title}>
              <h3 className="landing-footer-column-title">{title}</h3>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="landing-footer-link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-5 border-t border-neutral-800 pt-7 sm:flex-row">
          <p className="landing-footer-note">© 2026 PetCart. All rights reserved.</p>
          <div className="flex gap-3">
            {socialLinks.map(({ label, href, Icon }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="flex h-8 w-8 items-center justify-center rounded-full bg-neutral-800 text-neutral-400 transition-colors hover:text-white"
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
